import { useState } from 'react';
import { Table, Tag } from '@humanforce/mango-ui-react';
import type { OrgData, OrgExtra } from '../organisationFixtures';

interface BankingTabProps {
  orgId: string;
  orgData: OrgData;
  orgExtra: OrgExtra | undefined;
}

interface BankRow {
  name: string;
  bsbLabel: string;
  account: string;
  purpose: string;
  status: 'active' | 'inactive';
}

const columns = [
  { field: 'name', header: 'Account name', sortable: true },
  { field: 'bsbLabel', header: 'BSB / Sort code', sortable: true },
  { field: 'account', header: 'Account number', sortable: true },
  { field: 'purpose', header: 'Purpose', sortable: true },
  {
    field: 'status',
    header: 'Status',
    body: (row: unknown) => {
      const r = row as BankRow;
      return <Tag tone={r.status === 'active' ? 'positive' : 'neutral'} label={r.status} />;
    },
  },
];

export const BankingTab = ({ orgExtra }: BankingTabProps) => {
  const [selected, setSelected] = useState<BankRow[]>([]);

  if (orgExtra === undefined)
    return <div className="mgo-padding-l">Loading...</div>;

  const rows: BankRow[] = orgExtra.bankAccounts.map((b) => ({
    name: b.name,
    bsbLabel: `${b.bsbLabel} ${b.bsb}`,
    account: b.account,
    purpose: b.purpose,
    status: b.status,
  }));

  return (
    <div className="mgo-stack mgo-gap-l">
      <Table
        value={rows}
        columns={columns}
        selectable
        selection={selected}
        onSelectionChange={(sel) => setSelected(Array.isArray(sel) ? sel as BankRow[] : [sel as BankRow])}
      />
    </div>
  );
}
